import carGreen from '@/assets/icons/vehicles/car-2d/car-green-vertical.svg';
import carRed from '@/assets/icons/vehicles/car-2d/car-red-vertical.svg';
import carGrey from '@/assets/icons/vehicles/car-2d/car-grey-vertical.svg';
import carYellow from '@/assets/icons/vehicles/car-2d/car-orange-vertical.svg';
import carOrange from '@/assets/icons/vehicles/car-2d/car-orange-vertical.svg';

import bikeGreen from '@/assets/icons/vehicles/bike-2d/green.svg';
import bikeRed from '@/assets/icons/vehicles/bike-2d/red.svg';
import bikeGrey from '@/assets/icons/vehicles/bike-2d/grey.svg';
import bikeOrange from '@/assets/icons/vehicles/bike-2d/orange.svg';
import bikeyellow from '@/assets/icons/vehicles/bike-2d/red.svg';

import truckGrey2d from '@/assets/icons/vehicles/truck-2d/truck-sm-grey.svg';
import truckGreen2d from '@/assets/icons/vehicles/truck-2d/truck-sm-green.svg';
import truckOrange2d from '@/assets/icons/vehicles/truck-2d/truck-sm-orange.svg';
import truckRed2d from '@/assets/icons/vehicles/truck-2d/truck-sm-red.svg';
import truckYellow2d from '@/assets/icons/vehicles/truck-2d/truck-sm-red.svg';

import busGrey2d from '@/assets/icons/vehicles/bus-2d/bus-sm-grey.svg';
import busGreen2d from '@/assets/icons/vehicles/bus-2d/bus-sm-green.svg';
import busOrange2d from '@/assets/icons/vehicles/bus-2d/bus-sm-orange.svg';
import busRed2d from '@/assets/icons/vehicles/bus-2d/bus-sm-red.svg';
import busYellow2d from '@/assets/icons/vehicles/bus-2d/bus-sm-red.svg';

import tankerGrey2d from '@/assets/icons/vehicles/tanker-2d/tanker-grey.svg';
import tankerGreen2d from '@/assets/icons/vehicles/tanker-2d/tanker-green.svg';
import tankerOrange2d from '@/assets/icons/vehicles/tanker-2d/tanker-orange.svg';
import tankerRed2d from '@/assets/icons/vehicles/tanker-2d/tanker-red.svg';
import tankerYellow2d from '@/assets/icons/vehicles/tanker-2d/tanker-red.svg';

import travellerInactive2d from '@/assets/icons/vehicles/traveller-2d/traveller-inactive.svg';
import travellerActive2d from '@/assets/icons/vehicles/traveller-2d/traveller-active.svg';
import travellerIdle2d from '@/assets/icons/vehicles/traveller-2d/traveller-idle.svg';
import travellerStopped2d from '@/assets/icons/vehicles/traveller-2d/traveller-stopped.svg';

// import { BUS_ICONS } from "@/utils/icons";

export const DEFAULT_LOCATION = { lat: 12.9716, lng: 77.5946 };
export const VEHICLE_STATUS = {
  ALL: 'All',
  ACTIVE: 'Active',
  INATCTIVE: 'Inactive',
  IDLE: 'Idle',
  STOPPED: 'Stopped',
  NO_SIGNAL: 'nosignal',
  RUNNING: 'Running', // alias for Active
}

export const VEHICLE_STATUS_V2 = {
  RUNNING: 'Running', // Active (equals to) Running   
}

export const COLORS = {
  GREEN: "green",
  ORANGE: "orange",
  RED: "red",
  YELLOW: "yellow",
  VIOLET: "violet",
  GREY: "grey",
  BLACK: "black",
}

export const BIKE_ICONS = {
  [VEHICLE_STATUS.ACTIVE]: bikeGreen,
  [VEHICLE_STATUS.INATCTIVE]: bikeGrey,
  [VEHICLE_STATUS.IDLE]: bikeOrange,
  [VEHICLE_STATUS.STOPPED]: bikeRed,
  [VEHICLE_STATUS.NO_SIGNAL]: bikeyellow,
}
export const BUS_ICONS = {
  [VEHICLE_STATUS.ACTIVE]: busGreen2d,
  [VEHICLE_STATUS.INATCTIVE]: busGrey2d,
  [VEHICLE_STATUS.IDLE]: busOrange2d,
  [VEHICLE_STATUS.STOPPED]: busRed2d,
  [VEHICLE_STATUS.NO_SIGNAL]: busYellow2d,
}
export const TRUCK_ICONS = {
  [VEHICLE_STATUS.ACTIVE]: truckGreen2d,
  [VEHICLE_STATUS.INATCTIVE]: truckGrey2d,
  [VEHICLE_STATUS.IDLE]: truckOrange2d,
  [VEHICLE_STATUS.STOPPED]: truckRed2d,
  [VEHICLE_STATUS.NO_SIGNAL]: truckYellow2d,
}

export const CAR_ICONS = {
  [VEHICLE_STATUS.ACTIVE]: carGreen,
  [VEHICLE_STATUS.INATCTIVE]: carGrey,
  [VEHICLE_STATUS.IDLE]: carOrange,
  [VEHICLE_STATUS.STOPPED]: carRed,
  [VEHICLE_STATUS.NO_SIGNAL]: carYellow
}

export const TANKER_ICONS = {
  [VEHICLE_STATUS.ACTIVE]: tankerGreen2d,
  [VEHICLE_STATUS.INATCTIVE]: tankerGrey2d,
  [VEHICLE_STATUS.IDLE]: tankerOrange2d,
  [VEHICLE_STATUS.STOPPED]: tankerRed2d,
  [VEHICLE_STATUS.NO_SIGNAL]: tankerYellow2d
}

export const TRAVELLER_ICONS = {
  [VEHICLE_STATUS.ACTIVE]: travellerActive2d,
  [VEHICLE_STATUS.INATCTIVE]: travellerInactive2d,
  [VEHICLE_STATUS.IDLE]: travellerIdle2d,
  [VEHICLE_STATUS.STOPPED]: travellerStopped2d,
  // [VEHICLE_STATUS.NO_SIGNAL]: 
}

export const STATUS_COLOR_MAP = {
  [VEHICLE_STATUS.ACTIVE]: COLORS.GREEN,
  [VEHICLE_STATUS.INATCTIVE]: COLORS.GREY,
  [VEHICLE_STATUS.IDLE]: COLORS.ORANGE,
  [VEHICLE_STATUS.STOPPED]: COLORS.RED,
  [VEHICLE_STATUS.NO_SIGNAL]: COLORS.BLACK,
}

export const VEHICLE_TYPE = {
  CAR: 'car',
  BUS: 'bus',
  TRUCK: 'truck',
  BIKE: 'bike',
  TRAVELLER: 'traveller',
  TANKER: 'tanker',
}

export const VEHICLE_TO_ICON_MAP = {
  [VEHICLE_TYPE.CAR]: CAR_ICONS,
  [VEHICLE_TYPE.BIKE]: BIKE_ICONS,
  [VEHICLE_TYPE.BUS]: BUS_ICONS,
  [VEHICLE_TYPE.TRAVELLER]: TRAVELLER_ICONS,
  [VEHICLE_TYPE.TRUCK]: TRUCK_ICONS,
  [VEHICLE_TYPE.TANKER]: TANKER_ICONS,
}

export const SPEED_TO_COLOR_MAP = [
  {
    min: 0,
    max: 30,
    color: COLORS.GREEN
  },
  {
    min: 30,
    max: 60,
    color: COLORS.ORANGE,
  },
  {
    min: 60,
    max: 300,
    color: COLORS.RED,
  },
]

export const GEOFENCING_TYPES = {
  CIRCLE: 'circle',
  RECTANGLE: 'rectangle',
  POLYGON: 'polygon',
  POLYLINE: 'polyline',
  LINESTRING: 'LineString',
}

export const GEOFENCE = {
  // HOME: 'home',
  CITY: 'city geofence',
  // HAZARD: 'hazard',
  ALL: 'all geofence',
  GEOFENCE: 'geofence'
}

// This const is created for temperory purpose, remove once dependency resolved
export const CHANNEL_POOL_ID = 'VTS-DEV';

export const getIconByStatus = (status = VEHICLE_STATUS.ACTIVE, vehicleType = VEHICLE_TYPE.CAR) => VEHICLE_TO_ICON_MAP[vehicleType.toLowerCase()][status];

export const latLngFromString = (string, seperator = ",") => {
  if (!string) {
    return null;
  }
  let latLngArray = string.split(seperator);
  return {
    lat: +latLngArray[0],
    lng: +latLngArray[1],
  }
}
export const ensureLocationInNubmer = (marker) => marker && marker.lat && (marker.lon || marker.lng) ? { ...marker, lat: parseFloat(marker.lat), lng: parseFloat(marker.lng || marker.lon), latLng: [parseFloat(marker.lat), parseFloat(marker.lng || marker.lon)], latlng: { lat: parseFloat(marker.lat), lng: parseFloat(marker.lng || marker.lon) } } : marker;

export const ensureVehicleProperties = (marker, vehicle) => marker && vehicle ? { ...marker, vehicleType: vehicle.vehicleType, driverName: vehicle.driverName, driverContact: vehicle.driverContact, rtoNumber: vehicle.rtoNumber, data: { ...marker } } : marker;
// export const getColorBySpeed = (marker) => SPEED_TO_COLOR_MAP.find(cm => marker.speed >= cm.min && marker.speed < cm.max).color;

export const formatMarkerProperties = (marker) => {
  //TODO remo unwanted properties from the main marker object here. So only tracking related properites can be kept.
  //move evry other properties to data or related objects.
  marker.data = { ...marker };
  return marker;
}


export const getLocation = async () => {

  if (navigator.geolocation) {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject)
    );
  }
  return Promise.resolve(DEFAULT_LOCATION);
}

export const angleFromCoordinate = (lat1, long1, lat2, long2) => {
  // let dLon = long2 - long1;

  // let y = Math.sin(dLon) * Math.cos(lat2);
  // let x =
  //   Math.cos(lat1) * Math.sin(lat2) -
  //   Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

  // let brng = Math.atan2(y, x);

  // brng = (brng * 180) / Math.PI; // Math.toDegrees(brng);
  // brng = (brng + 360) % 360;
  // // brng = 360 - brng; // count degrees counter-clockwise - remove to make clockwise

  // return brng;

  var y = Math.sin(toRadians(long2 - long1)) * Math.cos(toRadians(lat2));
  var x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(toRadians(long2 - long1));
  var brng = Math.atan2(y, x);
  brng = toDegrees(brng);
  return brng;
}

export const toDegrees = (angle) => angle * (180 / Math.PI);

export const toRadians = (angle) => angle * (Math.PI / 180);

export const validateCoordinatesAndStatus = (oldLat, oldLng, newLat, newLng, oldStatus, newStatus) => {
  return oldLat != newLat || oldLng != newLng || oldStatus != newStatus;
};

export const createLocationsProp = (data) => {
  let location = {};
  if (data.properties.type === GEOFENCING_TYPES.CIRCLE) {
    location.CircleCenterLat = data.geometry.coordinates[1],
      location.CircleCenterLng = data.geometry.coordinates[0],
      location.CircleRadius = data.properties.radius,
      location.FenceCoordinates = []
  } else {
    //For rectangle
    location.FenceCoordinates = data.geometry.coordinates[0].map((cor) => {
      return { lat: cor[1], lng: cor[0] };
    });
  }
  return location;
}

export const calculateCenterPosition = (points) => {
  var longitudes = points.map((i) => i[0]);
  var latitudes = points.map((i) => i[1]);

  latitudes.sort();
  longitudes.sort();

  var lowX = latitudes[0];
  var highX = latitudes[latitudes.length - 1];
  var lowy = longitudes[0];
  var highy = longitudes[longitudes.length - 1];

  var centerX = lowX + ((highX - lowX) / 2);
  var centerY = lowy + ((highy - lowy) / 2);

  return { lat: centerX, lng: centerY };
}

export const getStoppageIcon = (stoppageCount = 0) => {

  var svg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 293.334 293.334" style="enable-background:new 0 0 293.334 293.334;"  xml:space="preserve">
<g><g>
		<path style="fill:red;" d="M146.667,0C94.903,0,52.946,41.957,52.946,93.721c0,22.322,7.849,42.789,20.891,58.878
			c4.204,5.178,11.237,13.331,14.903,18.906c21.109,32.069,48.19,78.643,56.082,116.864c1.354,6.527,2.986,6.641,4.743,0.212
			c5.629-20.609,20.228-65.639,50.377-112.757c3.595-5.619,10.884-13.483,15.409-18.379c6.554-7.098,12.009-15.224,16.154-24.084
			c5.651-12.086,8.882-25.466,8.882-39.629C240.387,41.962,198.43,0,146.667,0z M146.667,144.358
			c-28.892,0-52.313-23.421-52.313-52.313c0-28.887,23.421-52.307,52.313-52.307s52.313,23.421,52.313,52.307
			C198.98,120.938,175.559,144.358,146.667,144.358z"/><text  text-anchor="middle" x="145.667" y="115.196" fill="red" stroke-width="10px" font-size="5em">${stoppageCount}</text>
</g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>`;
  var url = "data:image/svg+xml," + encodeURIComponent(svg);
  return url;
}


export const stoppageMarkerPopup = (e) => {
  return ` 
              <div class="vts-popup">
              <div
      class="d-flex align-items-center pt-1 font-weight-bold"
      style="color: #68dabb"
    >
      <span class="nt-pushpin pr-1" ></span>
      Stop ${e.options.data.stopCount}
    </div>
    <div class="d-flex align-items-center pt-1" v-if="marker.location" style="color: #68dabb">
        <span class="nt-pin pr-1"></span>
        ${e.options.data.location}
    </div>
    <div class="d-flex align-items-center pt-1" v-if="marker.location" style="color: #68dabb">
        <span class=" nt-calendar-fill pr-1"></span>
        ${new Date(e.options.data.timestamp).toLocaleString()}
    </div>

    <div class="d-flex pt-2 justify-content-between">
        <div class="d-flex align-items-center" style="color: red">
            <span class="nt-clock"></span>
            <div class="ml-1">${(e.options.data.stopDuration / 60).toFixed(
    2
  )} Min</div>
        </div>
    </div>
    <div class="d-flex pt-2 justify-content-between">
        <div class="d-flex align-items-center" style="color: #68dabb">
            <span class="nt-radio-button-on-fill"></span>
            <div class="ml-1">
                ${e.options.data.lat
      .toString()
      .substring(0, 9)},${e.options.data.lng.toString().substring(0, 9)}
            </div>
        </div>
    </div>
</div>
  `
}


export const polylinePopup = (e) => {
  return ` 
              <div class="vts-popup">
                  <div class="d-flex align-items-center pt-1">
                    <div>
                      <span class="nt-person pr-1" style="color: #0b4fb5" ></span>
                      <span style="color:black">
                      ${e.options.data.driverName}
                      </span>
                    </div>
                    <div class="telephone-info" v-if="marker.driverContact">
                      <span class="c-chip" >
                        <span class="nt-phone pr-1" ></span>
                        ${e.options.data.driverContact}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center pt-1" v-if="marker.address" style="color:black">
                    <span class="nt-pin pr-1" style="color: #0b4fb5" ></span>
                    <span style="color:black"> 
                      ${e.options.data.address}
                    </span>
                  </div>
                  <div class="d-flex pt-1">
                    <span class="nt-bookmark pr-1" style="color: #68dabb" ></span>
                    <span class="pr-1" style="color:black"> ${e.options.data.rtoNumber} </span>
                  </div>

                  <div class="d-flex pt-1 justify-content-between">
                    <div>
                      <span class="nt-radio-button-on-fill" style="color: #68dabb" ></span>
                      <span style="color:black">
                      ${e.options.data.lat}
                      ${e.options.data.lng}
                      </span>
                    </div>
                    <div class="ml-2" >
                      <span class="nt-paper-plane" style="color: #68dabb" ></span>
                      <span style="color:black">
                        ${e.options.data.speed} km/h
                      </span>
                    </div>
                  </div>
                </div>
  `;
}